"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modelProperties = {
    modelName: 'JobItemGroup',
    tableName: 'JobItemGroup',
    associations: [{
            type: 'belongsTo',
            model: 'Company',
            parameters: { foreignKey: { name: 'company_id', fieldName: 'company_id' } },
        }, {
            type: 'hasMany',
            model: 'JobItem',
            parameters: { foreignKey: { name: 'jobitemgroup_id', fieldName: 'jobitemgroup_id' } },
            followFor: ['Archive', 'DocumentClone'],
            includeRestores: ['JobItemGroup'],
        }, {
            serverOnly: true,
            type: 'belongsTo',
            model: 'DocumentItem',
            parameters: { complexAssociationName: 'documentItem', foreignKey: { name: 'id', fieldName: 'id' }, targetKey: 'linked_id' },
        }, { type: 'belongsTo', model: 'Job', parameters: { foreignKey: { name: 'job_id', fieldName: 'job_id' } } }, {
            type: 'belongsTo',
            model: 'Job',
            parameters: {
                foreignKey: {
                    name: 'job_id',
                    fieldName: 'job_id',
                },
            },
        }],
};
exports.default = modelProperties;
//# sourceMappingURL=../../../../src/models/jobItemGroup/modelProperties.js.map